import { CatalogPriceZoneSPPriceFamily } from 'hooks/catalog-price-zone-service-provider';
import { Fragment, JSX } from 'react';
import { OrderPrestataireLine } from '.';
import { Col, Form, FormInstance, Row } from 'antd';
import { PriceType } from 'models';
import GenerateCatalogPriceSection from './GenerateCatalogPriceSection';

export interface FormValues {
  lineItems: {
    [key: string]: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      products: any;
    };
  };
}

interface PriceValueCellProps {
  form: FormInstance;
  value?: {
    uuid?: string;
    productId?: number;
    productName?: string;
    priceFamilies?: CatalogPriceZoneSPPriceFamily[];
    priceValue: string | number;
    catalogPriceValue?: string | number;
    isManualPrice?: boolean;
    wasInitiallyManual?: boolean;
    selectedPriceFamilyId?: number | null;
  }[];
  priceTypes: PriceType[];
  record: OrderPrestataireLine;
  updateDataSource?: (data: OrderPrestataireLine, serviceProviderId?: number) => void;
}

const PriceValueCell = (props: PriceValueCellProps) => {
  const {
    form,
    value,
    priceTypes,
    record,
    updateDataSource
  } = props;
  return (
    <section className='section'>
      {value?.map((item) => {
        const hasTarifSection = item?.priceFamilies && item.priceFamilies.length > 0;
        return (
          <div key={item.uuid + '-' + item.productId} className='generate-price-value-cell'>
            <GenerateCatalogPriceSection
              form={form}
              record={record}
              uuid={item.uuid}
              productId={item.productId}
              priceFamilies={item?.priceFamilies || []}
              priceTypes={priceTypes}
              selectedPriceFamilyId={item?.selectedPriceFamilyId}
              priceValue={item.priceValue}
              updateDataSource={updateDataSource}
            />
            {hasTarifSection && (
              <div className='generate-price-value-cell'>
                {generateTarifSectionSpace(item?.priceFamilies || [], item?.selectedPriceFamilyId)}
              </div>
            )}
          </div>
        );
      })}
    </section>
  );
};

const generateTarifSectionSpace = (priceFamilies: CatalogPriceZoneSPPriceFamily[], priceFamilyId?: number | null) => {
  let content: JSX.Element = <></>;
  const selectedPriceFamily = priceFamilies.find((priceFamily) => priceFamily.id === priceFamilyId);
  if (priceFamilies.length > 0) {
    content = (
      <>
        <Row gutter={[16, 0]} className='type-du-tarif'>
          <Col xs={{ span: 18 }} style={{ textAlign: 'right', paddingRight: 0 }}>
            <Form.Item initialValue={priceFamilyId}></Form.Item>
          </Col>
        </Row>
        {priceFamilyId && (
          <Row gutter={[16, 0]}>
            <Col xs={{ span: 24 }}>
              <Form.Item labelCol={{ span: 24 }} wrapperCol={{ span: 8 }} className='long-label-item'></Form.Item>
            </Col>
          </Row>
        )}
        {selectedPriceFamily?.prices?.map((tarif, indexTarif) => (
          <Fragment key={`${tarif?.id}-${indexTarif}`}>
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }} id='info-tarif'></Col>
            </Row>
            {tarif?.priceOptions?.map((priceOption, indexPriceOption) => (
              <Fragment key={`${priceOption?.id}-${indexPriceOption}`}>
                <Row gutter={[16, 0]}>
                  <Col xs={{ span: 24 }}>
                    <Form.Item labelCol={{ span: 24 }} wrapperCol={{ span: 8 }}></Form.Item>
                  </Col>
                </Row>
              </Fragment>
            ))}
            <Row gutter={[16, 0]}>
              <Col xs={{ span: 24 }}>
                <Form.Item labelCol={{ span: 24 }} wrapperCol={{ span: 8 }}></Form.Item>
              </Col>
            </Row>
          </Fragment>
        ))}
      </>
    );
  } else {
    content = (
      <>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} className='text-align-right'>
            <Form.Item></Form.Item>
          </Col>
        </Row>
      </>
    );
  }
  return <section className='section mt-2 mb-2 generate-tarif-section-empty-space'>{content}</section>;
};

export default PriceValueCell;
